/**
 * Generates an array of random integers
 * @param count - The number of integers to generate
 * @param max - The maximum value
 * @param min - The minimum value
 * @returns An array of random integers
 */
export const randomIntegers = ({
  count = 10,
  max = 100,
  min = 0
}) => {
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(Math.floor(Math.random() * (max - min + 1)) + min);
  }
  return result;
};